import { render } from "./ListaCarga.vue?vue&type=template&id=24fa8d4a&scoped=true&bindings={\"filas\":\"props\"}"
import script from "./ListaCarga.vue?vue&type=script&lang=js"
export * from "./ListaCarga.vue?vue&type=script&lang=js"

import "./ListaCarga.vue?vue&type=style&index=0&id=24fa8d4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24fa8d4a"

export default script